import { CopilotFeedbackContract } from '@terra/shared-contracts-copilot-feedback';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'chat';

export const copilotFeedbackClient = createTerraOrpcClient({
  contract: CopilotFeedbackContract,
  serviceName: SERVICE_NAME,
});
